export default {
    path: '/compensation',
    name: 'compensation',
    component: () => import('source/pages/CompensationWikiPage.vue'),
    meta: {
        title: 'Compensation Wiki',
        loginRequired: false,
    },
};
